<template>
<div class="container">
    <nav class="add-navigation">
      <div @click="$router.push({name: 'company-admin-campaings-ani-groups'})"
           class="back-link">
        <svg class="icon"
             width="30px"
             height="30px"
             viewBox="0 0 30 30"
             version="1.1">
          <path d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
                id="path-1">
          </path>
        </svg>
        <p>Back to Ani Group</p>
      </div>
      <div class="buttons-wrapper">
        <div @click="$router.push({name: 'company-admin-campaings-ani-groups'})"
             class="secondary-button">
          <secondary-button>Cancel</secondary-button>
        </div>
        <div class="primary-button">
          <primary-button @click.native="editAniGroup">Edit Ani Group</primary-button>
        </div>
      </div>
    </nav>
    <div class="add-container">
        <span class="container-title">Save Ani Group</span>
        <div class="col-wrapper" v-if="aniGroup">
          <div class="col">
            <primary-input type="text"
                           name="ani group name"
                           class="field"
                           v-model="aniGroup.ani_group_name"
                           v-validate="'required'"
                           :class="{'input': true, 'is-danger': errors.has('first name')}"
                           placeholder="Enter ani group name" />
            <div class="help is-danger"
                 v-if="errors.has('ani group name')">
              {{ errors.first('ani group name') }}
            </div>
            <div class="help is-danger"
                 v-if="aniGroupError">
              {{aniGroupError.ani_group_name ? aniGroupError.ani_group_name[0] : null}}
            </div>  
            <div class="list primary-input-container" v-if="anis">
              <p class="pimary-input-title">Select Numbers</p>
              <multiselect v-model="aniGroup.items"
                          :options="anis"
                          :multiple="true"
                          :close-on-select="false"
                          :clear-on-select="false"
                          :preserve-search="true"
                          placeholder="Pick Number"
                          label="number"
                          track-by="number"
                          :preselect-first="true">
                <template slot="selection"
                          slot-scope="{ values, search, isOpen, option }">
                  <span class="multiselect__single"
                        v-if="values.length &amp;&amp; !isOpen">{{ values.length }} numbers selected
                  </span>
                </template>
              </multiselect>
            </div>
            <div class="help is-danger"
                 v-if="errors.has('number')">
              {{ errors.first('number') }}
            </div>
            <div class="help is-danger"
                 v-if="aniGroupError">
              {{aniGroupError.number ? aniGroupError.number[0] : null}}
            </div>  
          </div>         
        </div>
    </div>
</div>
</template>

<script>
export default {
  components: {
    PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    SecondaryButton: () => import('@/components/Buttons/SecondaryButton.vue'),
    PrimaryButton: () => import('@/components/Buttons/PrimaryButton.vue'),
  },
  data: () => ({
    aniGroupError: null,
    aniGroupName: null,
    number: '',
    aniGroup: null,
    aniGroupNew: {
        ani_group_name: null,
        items: []
    },
    anis: [],
  }),
  created() {
      this.GetAniGroup();
      this.getNumberList();
  },
  methods: {
    getNumberList() {
      this.$store.dispatch("GetAllDids",{did_type : 'ANI'})
      .then((res) => {
        console.log("res.items[1]", res.items)
        this.anis = res.items.map( i => { return { 'number' : i.using.did_number} }) //using.did_number
      });
    },
    GetAniGroup(search, page) {
        let id = this.$route.params.id 
        this.$store.dispatch('GetAni', id).then(res => {
            console.log("res from GetAni------->", res);
            this.aniGroup = res;
            // let items = [456,789, 7888]
            // this.number += items.map((item) => {
            //     return ' ' + item;
            // })
            this.aniGroup.items = res.items.map( i => { return { 'number' : i} })
            console.log("numberrrrrrrrrrrrrr", this.number);
        })
    },
    editAniGroup() {      
      this.$validator.validate().then(result => {
        if (result) {
          this.aniGroupNew.ani_group_name = this.aniGroup.ani_group_name;
          // if(this.number.length > 1){
          //   this.number = this.number.replace(/ +?/g, '');
          //   console.log("splittttttttttedddddddddddd", this.number);
          //   this.aniGroupNew.items = this.number.split(',');
          //   console.log("splitttttttttt", this.number);          
          //   this.aniGroupNew.items = this.aniGroupNew.items.filter(Boolean);
          // } else {
          //   this.aniGroupNew.items.push(this.number);
          // }
          // this.aniGroupNew.items = this.aniGroupNew.items.filter(item => '"' + item + '"');
          this.aniGroupNew.items = this.aniGroup.items.map(i => i.number);
          console.log("this.aniGroupNew", this.aniGroupNew)
          this.$store
            .dispatch("EditAniGroup", 
                {
                    aniGroup: this.aniGroupNew,
                    id: this.$route.params.id
                }
            )
            .then(() => {
              this.$snotify.success("Ani Group have been edited.", {
                timeout: 6000
              });
                this.$router.push({ name: "company-admin-campaings-ani-groups" });
            })
            .catch(err => {
              if (err.errors) {
                this.aniGroupError = err.errors[0].aniGroup
                  ? err.errors[0].aniGroup
                  : null;
                setTimeout(() => {
                  this.aniGroupError = null;
                }, 6000);
              } else {
                
                this.$snotify.error(err.error.message, {
                  timeout: 6000
                });
              }
            });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.container{
    font-family: "Helvetica Neue";
    padding: 0 20px;
    .add-navigation {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 40px;
        width: 100%;
        margin-top: 20px;
        margin-bottom: 20px;
        .back-link {
          cursor: pointer;
          display: flex;
          align-items: center;
          fill: #51a3f3;
          color: #51a3f3;
          font-family: "Helvetica Neue";
          font-size: 16px;
          font-weight: 500;
          line-height: 20px;
          p {
              margin-bottom: 0;
            }
        }
        .buttons-wrapper {
        display: flex;
        align-items: center;
        width: fit-content;
        .primary-button {
            height: 40px;
            width: 146px;
        }
        .secondary-button {
            height: 40px;
            width: 90px;
            margin-right: 20px;
          }
        }
    }
    .add-container {
        flex-direction: column;
        align-items: center;
        height: 375px;
        background-color: #FFFFFF;
        padding-top: 15px;
        .container-title {
            height: 30px;	
            width: 432px;	
            color: #000000;		
            font-size: 18px;	
            font-weight: 500;	
            line-height: 30px;
            padding: 15px 0 15px 15px;
        }
        .col-wrapper {
            width: 100%;
            display: flex;
            justify-content: space-between;
            margin-left: 15px;
            margin-top: 20px;
            .col {
                width: 100%;
                padding-right: 15px;
                .input {
                    margin-bottom: 20px;
                }
                .field {
                  width: 60%;
                  p.pimary-input-title {
                    color: #000000;
                    font-family: ""Helvetica Neue"";
                    font-size: 12px;
                    font-weight: 300;
                  }
                }
                .upload-photo, #dropzone {
                  min-height: 285px;
                  min-height: 285px;
                  border-radius: 4px;
                  width: 100%;
                  .dz-image {
                        padding: 5px;
                        img {
                            height: 150px;
                            width: 150px;
                            border-radius: 50px;
                            
                        }                       
                    }
                  
                }
                .pimary-input-title {
                    color: #000000;
                    font-family: ""Helvetica Neue"";
                    font-size: 12px;
                    font-weight: 300;
                    letter-spacing: 0.21px;
                    line-height: 15px;
                    margin-bottom: 5px;
                    text-transform: uppercase;
                }
                .upload-contaioner {
                    border: 1px solid #5171F3;	
                    border-radius: 4px;
                    background-color: #FFFFFF;
                    height: 265px;
                    border-style: dashed;
                    margin-right: 15px;
                    position: relative;
                    input[type=file]{
                        position: absolute;
                        height: 36px;	
                        width: 136px;
                        opacity: 0;
                        cursor: pointer;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        -ms-transform: translate(-50%, -50%); /* IE 9 fix */
                        z-index: 1;
                    }
                    .upload-button {
                        height: 36px;	
                        width: 136px;	
                        border-radius: 4px;	
                        background-color: #51A3F3;
                        margin: 0;
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                    }
                }
            }
        }
        .email-input {
            margin-bottom: 20px;
        }
        .password-input {
            margin-bottom: 30px;
        }
        .first {
            margin-bottom: 30px;
            .remember-me {
                display: flex;
                align-items: center;
                input {
                    margin-right: 5px;
                }
            }
        }
    }
}    
</style>

